import { Select } from 'antd';
import { Form } from '@common/components';
import React from 'react';

const rules = [{ required: true, message: 'Please select a code' }];

const dropdownStyle = { minWidth: '15%' };

type Props = { payCodes: string[]; onSelect?: () => void };

export const DisputePayCodeInput = ({ payCodes, onSelect }: Props) => (
  <Form.Item name="newPayCode" rules={rules}>
    <Select
      size="large"
      showSearch
      optionFilterProp="children"
      placeholder="Code"
      dropdownStyle={dropdownStyle}
      onSelect={onSelect}
    >
      {payCodes.map((payCode, idx) => (
        <Select.Option className="select-option" key={idx} value={payCode}>
          {payCode}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
